import { Controller } from '@hotwired/stimulus';
import { useCollectionEventListeners } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['toggler', 'togglee'];

  connect() {
    useCollectionEventListeners(this, this.togglerTargets, 'click', this.toggle);
  }

  toggle(e) {
    e.preventDefault();
    Array.from(this.toggleeTargets).forEach((togglee) => {
      if (togglee.classList.contains('hidden')) {
        togglee.classList.remove('hidden');
      } else {
        togglee.classList.add('hidden');
      }
    });
  }
}
